import { render, staticRenderFns } from "./userFile.vue?vue&type=template&id=677b07ba&scoped=true"
import script from "./userFile.vue?vue&type=script&lang=js"
export * from "./userFile.vue?vue&type=script&lang=js"
import style0 from "./userFile.vue?vue&type=style&index=0&id=677b07ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b07ba",
  null
  
)

export default component.exports